
export function getQueryStringByName(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] === variable){return pair[1];}
    }
    return "";
}

export function sleep(time){
    return new Promise((resolve, reject)=>{
        setTimeout(()=>{
            resolve()
        },time)
    })
}

export function isNull( str ){
    if ( str === "" ) return true;
    var regu = "^[ ]+$";
    var re = new RegExp(regu);
    return re.test(str);
}


